import React, { useRef } from 'react';
import { Button, Modal, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker2";
import "react-datepicker2/src/styles/style.css";
import Loader from 'react-loader-spinner';
import { CaretLeftFill, CaretRightFill, PencilFill, Search, Trash, X } from "react-bootstrap-icons";
import { deleteReminder, getReminder, readReminder, searchReminders, setReminderPop } from '../store/api/ReminderAPI';
import { setDialog } from "../store/api/GetAllProduct";
let totalPage = 0;

const ModalSearchReminders = (props) => {

    const currPage = useRef(1);
    const searchData = useRef({});
    const dateFrom = useRef();
    const dateTo = useRef();
    const { showModal, setShow, isRead } = props;
    const reminders = useSelector(state => state.UserReducer.reminders);
    if (totalPage < 1) {
        const t = reminders && reminders.TotalCount ? Number(reminders.TotalCount) : 0;
        totalPage = Math.floor(t / 10) + ((t % 10) > 0 ? 1 : 0);
    }

    const dispatch = useDispatch();
    const search = (reset) => {
        if (reset) {
            currPage.current = 1;
            totalPage = 0;
        }
        if (dateFrom.current.input.value === "") {
            searchData.current.AlarmDate = null;
        }
        if (dateTo.current.input.value === "") {
            searchData.current.AlarmDateTo = null;
        }
        searchData.current.Skip = currPage.current - 1;
        searchData.current.Take = 10;
        if (isRead !== undefined) {
            searchData.current.IsRead = isRead;
        }
        dispatch(searchReminders(searchData.current));
    }
    const changePage = (inc) => {
        if (inc) {
            currPage.current++;
        }
        else {
            currPage.current--;
        }
        search();
    }
    const onSuccess = () => {
        currPage.current = 1;
        totalPage = 0;
        dispatch(searchReminders(searchData.current));
    }
    const read = (id) => {
        dispatch(readReminder(id, onSuccess));
    }
    const showReminder = (id) => {
        const onSuccess = (rem) => {
            dispatch(setReminderPop({ show: true, reminder: rem }));
        }
        dispatch(getReminder(id, onSuccess));
    }
    const close = () => {
        setShow(false);
    }
    return (
        <Modal size="lg" show={showModal} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header style={{ backgroundColor: '#e40375' }}> جستجوی یادآوری ها<span onClick={close} style={{ cursor: "pointer" }}><X size={20} /></span></Modal.Header>
            <Modal.Body >
                <div className='row'>
                    <div className='col-md-3 form-group'>
                        <label>نوع یادآوری:</label>
                        <select className='form-control' onChange={e => searchData.current.AttachmentTypes = e.target.value}>
                            <option value="">انتخاب کنید</option>
                            <option value="Sale,Purchase,ReturnFromSale,ReturnFromPurchase,OutOfOrder,Borrow,ReturnFromBorrow,OldParts,Resid,Havaleh,Transfer,PreSale,PrePurchase">فاکتورهای انبار</option>
                            <option value="install,repair">سرویس ها</option>
                            <option value="customer,pre_customer">مشتریان</option>
                            <option value="staff">نمایندگان/تکنسین ها/پرسنل</option>
                            <option value="acc_doc">سندهای حسابداری</option>
                            <option value="cheque">چکها</option>
                            <option value="all">عمومی</option>
                        </select>
                    </div>
                    <div className='col-md-3 form-group'>
                        <label>از تاریخ:</label>
                        <DatePicker ref={dateFrom} isGregorian={false} timePicker={false} className="form-control"

                            onChange={value => { searchData.current.AlarmDate = value.local("en").format("YYYY/MM/DD") }} />
                    </div>
                    <div className='col-md-3 form-group'>
                        <label>تا تاریخ:</label>
                        <DatePicker ref={dateTo} isGregorian={false} timePicker={false} className="form-control"

                            onChange={value => { searchData.current.AlarmDateTo = value.local("en").format("YYYY/MM/DD") }} />
                    </div>
                    <div className='col-md-3 form-group'>
                        <label>&nbsp;</label>
                        <Button className="group-Btn mt-1" style={{ display: "block" }} onClick={() => search(true)}><Search />&nbsp;جستجوی یادآوری</Button>
                    </div>
                </div>
                <Table className='mt-1'>
                    <thead>
                        <tr>
                            <th>تاریخ یادآوری</th>
                            <th>نوع یادآوری</th>
                            <th>متن یادآوری</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {reminders === "PENDING" &&
                            <tr>
                                <td colSpan={4} style={{ textAlign: "center" }}><Loader type="BallTriangle" width={25} height={25} color="#bb1370" /></td>
                            </tr>
                        }
                        {reminders?.Data && Array.isArray(reminders.Data) && reminders.Data.map((item, i) =>
                            <tr key={i} className="resultTableRow">
                                <td style={{ width: "110px" }}>{item.PAlarmDate + "-" + item.AlarmHour}</td>
                                <td style={{ width: "120px" }}>{item.PAttachmentType}</td>
                                <td>{item.RemBody}</td>
                                <td style={{ width: "120px" }}>
                                    <Trash className='rowBtn' size={18} color="red" onClick={() => {
                                        dispatch(setDialog({
                                            status: 'show',
                                            arrayBtn: ['yes', 'no'],
                                            dialogTitle: 'حذف یادآوری',
                                            dialogText: 'آیا از حذف مطمئن هستید؟',
                                            okOperation: deleteReminder(item.ID, onSuccess)
                                        }))
                                    }} />
                                    &nbsp;
                                    <PencilFill className='rowBtn' size={18} color="orange" onClick={() => showReminder(item.ID)} />
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
                <div>
                    <button className="btn btn-block" style={{ padding: "2px", marginRight: "2px" }} title='صفحه قبل' disabled={currPage.current === 1} onClick={() => { changePage(false) }}><CaretRightFill size={25} /></button>
                    <span>{currPage.current + " از " + totalPage}</span>
                    <button className="btn btn-block" style={{ padding: "2px", marginLeft: "2px" }} title='صفحه بعد' disabled={currPage.current === totalPage} onClick={() => changePage(true)}><CaretLeftFill size={25} /></button>
                </div>
            </Modal.Body>
        </Modal >
    )
}
export default ModalSearchReminders;